import { DefaultBaseMapLayer } from '../layerModel/baseLayers/defaultBaseMapLayer';
import { GeoServerBaseMapLayer } from '../layerModel/baseLayers/geoServerBaseMapLayer';
import { MapTilerBaseMapLayer } from '../layerModel/baseLayers/mapTilerBaseMapLayer';
import { OverlayBasicLayer } from '../layerModel';
import { OverlayCustomLayer } from '../layerModel/overlayLayers/overlayCustomLayer';
import { OverlayEmptyLayer } from '../layerModel/overlayLayers/overlayEmptyLayer';
/**
 * The LayersValidator class is converts plain objects that
 * enter dinapsis-map component to the right layer class and checks if conversion is valid
 * or not.
 */
export class LayersValidator {
    /**
     * Validate the base layers
     * @param {any} baseLayers - A plain object that should match an interface of a base layer
     * @returns Nothing. If validation fails trows an exception
     */
    validateBaseLayers(baseLayers) {
        baseLayers.forEach((baseLayer) => {
            if (baseLayer.type === 'MaptilerBaseMapLayer') {
                const obj = this.initializeMapTilerBaseLayer(baseLayer);
                obj.validate();
            }
            else if (baseLayer.type === 'GeoServerBaseMapLayer') {
                const obj = this.initializeGeoServerBaseLayer(baseLayer);
                obj.validate();
            }
            else if (baseLayer.type === 'DefaultBaseMapLayer') {
                const obj = new DefaultBaseMapLayer(baseLayer.id, baseLayer.isActive);
                obj.validate();
            }
            else {
                throw new Error('BaseLayer not supported');
            }
        });
    }
    /**
     * Validate the overlay layers
     * @param overlayLayers Overlay layers
     */
    validateOverlayLayers(overlayLayers) {
        overlayLayers.forEach((overlayLayer) => {
            let obj;
            switch (overlayLayer.type) {
                case 'OverlayBasicLayer':
                    obj = this.initializeBasicOverlayLayers(overlayLayer);
                    obj.validate();
                    break;
                case 'OverlayCustomLayer':
                    obj = this.initializeCustomOverlayLayers(overlayLayer);
                    obj.validate();
                    break;
                case 'OverlayEmptyLayer':
                    obj = this.initializeEmptyOverlayLayers(overlayLayer);
                    obj.validate();
                    break;
                default:
                    throw new Error('OverlayLayer not supported');
            }
        });
    }
    /**
     * Initializes and validates a MapTilerBaseMapLayer from plain object of the properties of the map
     * @param layer the layer plain object that comes from properties of dinapsis-bar
     * @returns a MapTilerBaseMapLayer
     */
    initializeMapTilerBaseLayer(layer) {
        return new MapTilerBaseMapLayer(layer.id, layer.name, layer.url, layer.type, layer.isActive, layer.apiKey, layer.thumbnail, layer.attribution);
    }
    /**
     * Initializes and validates a GeoServerBaseMapLayer from plain object
     * of the properties of the map
     * @param layer the layer plain object that comes from properties of dinapsis-map
     * @returns a GeoServerBaseMapLayer
     */
    initializeGeoServerBaseLayer(layer) {
        return new GeoServerBaseMapLayer(layer.id, layer.name, layer.url, layer.type, layer.isActive, layer.viewparams, layer.layers, layer.thumbnail, layer.attribution);
    }
    /**
     * Initializes and validate a OverlayBasicLayer from plain object
     * of the properties of the map
     * @param layer The layer plain object that comes from properties of dinapsis-map
     * @returns a OverlayBasicLayer
     */
    initializeBasicOverlayLayers(layer) {
        return new OverlayBasicLayer(layer.id, layer.name, layer.url, layer.type, layer.isVisible, layer.legend, layer.layers, layer.center, layer.selectable, layer.version, layer.opacity, layer.format, layer.subtitle, layer.nameLegend, layer.hidden, layer.bbox);
    }
    /**
     * Initializes and validate a OverlayCustomLayer from plain object
     * of the properties of the map
     * @param layer The layer plain object that comes from properties of dinapsis-map
     * @returns a OverlayCustomLayer
     */
    initializeCustomOverlayLayers(layer) {
        return new OverlayCustomLayer(layer.id, layer.name, layer.url, layer.type, layer.isVisible, layer.layers, layer.center, layer.selectable, layer.version, layer.opacity, layer.format, layer.subtitle, layer.nameLegend, layer.hidden, layer.bbox);
    }
    /**
     * Initializes and validate a OverlayCustomLayer from plain object
     * of the properties of the map
     * @param layer The layer plain object that comes from properties of dinapsis-map
     * @returns a OverlayCustomLayer
     */
    initializeEmptyOverlayLayers(layer) {
        return new OverlayEmptyLayer(layer.id, layer.name, layer.type, layer.isVisible, layer.legend, layer.selectable, layer.opacity, layer.format, layer.subtitle, layer.nameLegend, layer.hidden);
    }
}
//# sourceMappingURL=layersValidator.js.map